import React from 'react';
interface OrnamentProps {
  variant: 'flourish' | 'diamond' | 'leaf';
  className?: string;
  color?: string;
  opacity?: number;
}
export function Ornament({
  variant,
  className = '',
  color = 'currentColor',
  opacity = 0.4
}: OrnamentProps) {
  const baseClasses = `mx-auto block ${className}`;
  const style = {
    opacity,
    color
  };
  if (variant === 'flourish') {
    return <svg className={baseClasses} style={style} width="200" height="40" viewBox="0 0 200 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-170">
        <path d="M10 20 C 30 20, 40 5, 60 5 C 80 5, 90 20, 95 20 M190 20 C 170 20, 160 5, 140 5 C 120 5, 110 20, 105 20" stroke={color} strokeWidth="1" strokeLinecap="round" data-id="element-171" />
        <path d="M60 5 C 70 5, 75 15, 70 25 C 65 35, 50 35, 45 25 C 40 15, 50 10, 60 15" stroke={color} strokeWidth="1" strokeLinecap="round" data-id="element-172" />
        <path d="M140 5 C 130 5, 125 15, 130 25 C 135 35, 150 35, 155 25 C 160 15, 150 10, 140 15" stroke={color} strokeWidth="1" strokeLinecap="round" data-id="element-173" />
        <circle cx="100" cy="20" r="2" fill={color} data-id="element-174" />
        <circle cx="90" cy="20" r="1" fill={color} data-id="element-175" />
        <circle cx="110" cy="20" r="1" fill={color} data-id="element-176" />
      </svg>;
  }
  if (variant === 'diamond') {
    return <svg className={baseClasses} style={style} width="140" height="20" viewBox="0 0 140 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-177">
        <line x1="0" y1="10" x2="60" y2="10" stroke={color} strokeWidth="1" data-id="element-178" />
        <line x1="80" y1="10" x2="140" y2="10" stroke={color} strokeWidth="1" data-id="element-179" />
        <rect x="70" y="6" width="6" height="6" transform="rotate(45 70 6)" stroke={color} strokeWidth="1" fill="none" data-id="element-180" />
      </svg>;
  }
  if (variant === 'leaf') {
    return <svg className={baseClasses} style={style} width="120" height="30" viewBox="0 0 120 30" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-181">
        <path d="M10 15 Q 60 15 110 15" stroke={color} strokeWidth="1" strokeLinecap="round" data-id="element-182" />
        {/* Left leaves */}
        <path d="M30 15 Q 40 5 50 15" stroke={color} strokeWidth="1" fill="none" data-id="element-183" />
        <path d="M30 15 Q 40 25 50 15" stroke={color} strokeWidth="1" fill="none" data-id="element-184" />
        {/* Right leaves */}
        <path d="M70 15 Q 80 5 90 15" stroke={color} strokeWidth="1" fill="none" data-id="element-185" />
        <path d="M70 15 Q 80 25 90 15" stroke={color} strokeWidth="1" fill="none" data-id="element-186" />
        {/* Center leaves */}
        <path d="M50 15 Q 60 0 70 15" stroke={color} strokeWidth="1" fill="none" data-id="element-187" />
        <path d="M50 15 Q 60 30 70 15" stroke={color} strokeWidth="1" fill="none" data-id="element-188" />
      </svg>;
  }
  return null;
}